import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MobileContextService, ContextoPWA } from '@core/context/services/mobile-context.service';
import { ItemEducacionalColorService } from '@core/context/services/item-educacional-color.service';

@Component({
  selector: 'app-context-card',
  templateUrl: './context-card.component.html'
})
export class ContextCardComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  contexto: ContextoPWA | null = null;
  contextoExpandido = false;

  constructor(
    private contextService: MobileContextService,
    public colorService: ItemEducacionalColorService
  ) {}

  ngOnInit(): void {
    this.contexto = this.contextService.getContextoAtual();
    if (this.contexto?.componentes && this.contexto.componentes.length) {
      this.colorService.setContextComponentes(this.contexto.componentes);
    }
    this.contextService.contexto$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(contexto => {
      this.contexto = contexto;
      if (contexto?.componentes && contexto.componentes.length) {
        this.colorService.setContextComponentes(contexto.componentes);
      }
      if (!contexto) {
        this.contextoExpandido = false;
      }
    });
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get contextActionLabel(): string {
    return this.contexto?.turma?.id ? 'Alterar contexto' : 'Selecionar contexto';
  }

  toggleContexto(): void {
    this.contextoExpandido = !this.contextoExpandido;
  }

  getComponentesLength(): number {
    return this.contexto?.componentes?.length || 0;
  }

  getComponenteColor(componente: { id: number; color?: string; originalIndex?: number }, index: number): string {
    // originalIndex garante cor idêntica à do modal; sem ele, cai no índice do *ngFor
    if (typeof componente.originalIndex === 'number') {
      return this.colorService.getColorByIndex(componente.originalIndex);
    }
    return this.colorService.getColorByIndex(index);
  }

  abrirModalContexto(): void {
    window.dispatchEvent(new CustomEvent('abrirModalContexto'));
  }
}
